import React, { useContext } from 'react'
// import GetfeatureFields from './GetfeatureFields'
import SimpleInputField from '../../Custom/CustomInput/SimpleInputField'
import { validateInputField } from '../../Utility/Utility.js'
import SearchFieldsContext from '../context/context'

const FeaturesFilter = () => {
    // const SearchFields = useContext(SearchFieldsContext)
    const { searchFields, setSearchFields } = useContext(SearchFieldsContext)

    function handleChange(e) {

        const { id, value, placeholder } = e.target
        const i = searchFields.featureFields.findIndex(x => x.label === id)
        const newSearchFields = searchFields
        const maxInputValue = newSearchFields.featureFields[i].maxInputValue ? newSearchFields.featureFields[i].maxInputValue : ''

        const newValue = validateInputField(value, newSearchFields.featureFields[i].type, maxInputValue)

        if (placeholder === 'Min' || placeholder === '') {
            newSearchFields.featureFields[i] = { ...newSearchFields.featureFields[i], minValue: newValue }
        } else {
            newSearchFields.featureFields[i] = { ...newSearchFields.featureFields[i], maxValue: newValue }
        }
        setSearchFields({ ...newSearchFields })
    }

    return (
        <>
            <div className="flex flex-col gap-2">
                {searchFields ?
                    searchFields.featureFields.map(value => {
                        return (
                            <>
                                <div className="text-2">
                                    <label>{value.label}</label>
                                </div>
                                <div className="mb-3">
                                    <div className="flex flex-row space-x-2 sm:space-x-4">
                                        <SimpleInputField testid={`Min-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Min' : ''} id={value.label} value={value.minValue} classes={value.isMinMax ? '' : 'w-full'}></SimpleInputField>
                                        {value.isMinMax ?
                                            <SimpleInputField testid={`Max-${value.fieldName}`} onChange={handleChange} type={value.type} placeholder={value.isMinMax ? 'Max' : ''} id={value.label} value={value.maxValue} ></SimpleInputField>
                                            : null
                                        }
                                    </div>
                                </div>
                            </>
                        )
                    }) : null}
            </div>
        </>
    )
}

export default FeaturesFilter
